import { ClipboardCheck, Mail, MessageSquare, Search } from "lucide-react";
import { ThankYouPage } from "@/components/site/ThankYouPage";
import { checkoutHref } from "@/content/offers";
import { STRATEGY_SESSION } from "@/content/events";

const StrategySessionThankYou = () => (
  <ThankYouPage
    metaTitle="Application Received · Strategy Session · Dr. Sully Speaks"
    metaDescription="Your strategy session application is in. Here's how the review works, when you'll hear back, and how to prepare."
    path="/strategy-session/thank-you"
    eyebrow="Application received"
    heading="We've got your application"
    intro={`Every application is read personally. Want to skip the wait? Lock your spot now with the ${STRATEGY_SESSION.durationMin}-minute session (${STRATEGY_SESSION.priceLabel}) — we'll confirm your time within one business day.`}
    steps={[
      {
        icon: Mail,
        title: "Receipt confirmation",
        when: "Within 5 minutes",
        desc: "A short confirmation email lands in your inbox. Add Dr. Sully Speaks to your contacts so the follow-up doesn't get filtered.",
      },
      {
        icon: Search,
        title: "Personal fit review",
        when: "Within 1 business day",
        desc: "We review your situation, timeline, and desired outcome against the work we actually do. If it isn't a fit, we'll tell you straight and point you somewhere better.",
      },
      {
        icon: MessageSquare,
        title: "Session times or a referral",
        when: "After review",
        desc: "If it's a fit, you'll get a reply with strategy session times. The session is a working conversation — clarity on the problem, the path, and what it takes.",
      },
      {
        icon: ClipboardCheck,
        title: "Come prepared",
        when: "Before the call",
        desc: "Bring the specifics: what's happening, what you've already tried, and what a win looks like in 90 days. The more concrete you are, the more useful the session is.",
      },
    ]}
    primary={{ label: `Confirm my spot · ${STRATEGY_SESSION.priceLabel}`, href: checkoutHref(STRATEGY_SESSION.priceId) }}
    secondary={[
      {
        label: "Grab the Free Starter Kit",
        href: "/free",
        desc: "Not ready to pay yet? Start here while we review your application.",
      },
      {
        label: "See the MAKECHANGE framework",
        href: "/framework",
        desc: "The 10 pillars behind every strategy session — read it before we talk.",
      },
      {
        label: "Browse the books & eBooks",
        href: "/ebooks",
        desc: "Start applying the work today while your application is under review.",
      },
    ]}
    footnote="Applications are reviewed for fit only. Submitting an application does not create a client, clinical, or legal relationship, and no specific outcome is promised or guaranteed."
  />
);

export default StrategySessionThankYou;
